import { render, staticRenderFns } from "./PaymentPendingPage.vue?vue&type=template&id=22ddf114&"
import script from "./PaymentPendingPage.vue?vue&type=script&lang=js&"
export * from "./PaymentPendingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports